import React from "react";

import { KeyboardArrowDown } from "@libraries/icons";

// Languages
import { GlobalMessages } from "src/languages/interfaces";
import useTranslation from "@languages/useTranslation";

import * as Styled from "./styles";

interface Props {
  onClick: () => void;
}

const ShowMoreButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Styled.ShowMoreButton
      variant="contained"
      size="small"
      type="button"
      text={t(
        GlobalMessages.showMore
      ).toUpperCase()}
      endIcon={<KeyboardArrowDown />}
      onClick={onClick}
    />
  );
};

export default ShowMoreButton;
